import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface CalculatePhase {
  phaseNumber: number
  iterativeConceptId: string
  targetConceptId: string
  activationConcepts: Array<[]>
  targetTypeId: string
  processId: string
}

export async function getCalculatePhases(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['phases.payroll_id=:payrollId']
  if (search) {
    where.push(
      `CONCAT(phases.phase_number,concept_iterative.name,concept_target.name,target_types.name) ILIKE '%${search}%'`
    )
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? (modifier = [
        'group by phases.id,concepts.name,target_types.name,concept_iterative.name,concept_target.name',
        `order by ${dataOrder[1]} ${dataOrder[0]}`
      ])
    : (modifier = [
        'group by phases.id,concepts.name,target_types.name,concept_iterative.name,concept_target.name',
        'order by phases.phase_number asc'
      ])
  // result
  const response: any = await getData({
    tables: ['pg_phases'],
    fields: [
      'phases.id',
      'phases.phase_number',
      'concept_iterative.name as conceptIterative',
      'concept_target.name as conceptTarget',
      'target_types.name as typeName',
      "coalesce(string_agg(distinct concepts_m.name,','),'') as concepts_name",
      'phases.updated_at'
    ],
    join: [
      'INNER JOIN concepts ON phases.target_concept_id = concepts.id',
      'INNER JOIN concepts concept_iterative ON phases.iterative_concept_id = concept_iterative.id',
      'INNER JOIN concepts concept_target ON phases.target_concept_id = concept_target.id',
      'LEFT JOIN LATERAL jsonb_array_elements_text(phases.activation_concepts) c(concept) ON TRUE',
      'LEFT JOIN concepts concepts_m ON concepts_m.id = c.concept::uuid',
      'INNER JOIN target_types ON phases.target_type_id = target_types.id'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response[0]
}

export async function getCalculatePhase(id: string): Promise<CalculatePhase> {
  const data = await getData<any>({
    tables: ['pg_phases'],
    fields: [
      'id',
      'phases.payroll_id as payrollId',
      'phases.phase_number as phaseNumber',
      'phases.iterative_concept_id as iterativeConceptId',
      'phases.target_concept_id as targetConceptId',
      'phases.activation_concepts as activationConcepts',
      'phases.target_type_id as targetTypeId',
      'phases.process_id as processId',
      'phases.custom_fields as custom'
    ],
    where: [`phases.id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createCalculatePhase(
  data: CalculatePhase
): Promise<boolean> {
  const response: any = await http.post('calculation/phases', {
    phaseNumber: Number(data.phaseNumber),
    iterativeConceptId: data.iterativeConceptId,
    targetConceptId: data.targetConceptId,
    activationConcepts: data.activationConcepts,
    targetTypeId: data.targetTypeId,
    processId: data.processId,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateCalculatePhase(
  data: CalculatePhase,
  id: string
): Promise<boolean> {
  const response: any = await http.put('calculation/phases/' + id, {
    phaseNumber: Number(data.phaseNumber),
    iterativeConceptId: data.iterativeConceptId,
    targetConceptId: data.targetConceptId,
    activationConcepts: data.activationConcepts,
    targetTypeId: data.targetTypeId,
    processId: data.processId,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteCalculatePhase(id: string): Promise<boolean> {
  const response: any = await http.delete('calculation/phases/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
